"use client";

import { cn } from "@workspace/ui/lib/utils";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

type DashboardContentFrameProps = {
  children: ReactNode;
  orgSlug: string;
};

export function DashboardContentFrame({
  children,
  orgSlug,
}: DashboardContentFrameProps) {
  const pathname = usePathname();
  const containedScrollPath = `/${orgSlug}/contabilidad`;
  const hasContainedScroll = pathname === containedScrollPath;
  // The reconciliation workbench owns the viewport on desktop so its action bar
  // never falls below the fold, and scrolls like an ordinary page below `lg`.
  const hasDesktopContainedScroll = pathname.startsWith(
    `/${orgSlug}/conciliacion/`
  );

  return (
    <div
      className={cn(
        "flex min-h-0 flex-1 flex-col",
        hasContainedScroll && "h-full overflow-hidden",
        !hasContainedScroll && "overflow-y-auto",
        !hasContainedScroll &&
          hasDesktopContainedScroll &&
          "lg:h-full lg:overflow-hidden"
      )}
    >
      <div
        className={cn(
          "@container/main flex flex-1 flex-col",
          hasContainedScroll && "h-full min-h-0 gap-0",
          !hasContainedScroll && "gap-2",
          !hasContainedScroll &&
            hasDesktopContainedScroll &&
            "lg:h-full lg:min-h-0 lg:gap-0"
        )}
      >
        {children}
      </div>
    </div>
  );
}
